import React from 'react'
import "./Loader.css"

const Loader = () => {
    return (
        <div className="loaderWrap">
            <div className="loaderRing"><div>
            </div><div></div><div>
                </div><div></div></div>
        </div>
    )
}

export default Loader